import { useState } from "react";

export const RoleDetailPublish = () => {
    const [tab, setTab] = useState("tab-2");
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">역할 상세보기</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <h5 className="subheading">역할 정보</h5>

                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>역할 ID</th>
                            <td style={{ width: "31.3%" }}>Group Admin</td>
                            <th style={{ width: "16.66%" }}>관리자</th>
                            <td>000</td>
                        </tr>
                        <tr>
                            <th>생성일자</th>
                            <td>2024.05.05</td>
                            <th>생성자</th>
                            <td>SYSTEM</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="mybtns_group">
                <div className="btn-group" role="group" aria-label="">
                    <button type="button" className={tab == "tab-1" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-1")}>역할정보</button>
                    <button type="button" className={tab == "tab-2" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-2")}>접근권한</button>
                    <button type="button" className={tab == "tab-3" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-3")}>구성원</button>
                </div>
                <div className="mybtns_group_toolbar"></div>
            </div>

            <div className="content_wrap">
                <h5 className="subheading">수주</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>수주</th>
                            <td style={{ width: "16.66%" }}>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
                                        <label className="form-check-label" for="inlineRadio1">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                                        <label className="form-check-label" for="inlineRadio2">편집</label>
                                    </div>
                                </div>
                            </td>
                            <th style={{ width: "16.66%" }}>출하</th>
                            <td style={{ width: "16.66%" }}>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio3" value="option1" />
                                        <label className="form-check-label" for="inlineRadio3">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio4" value="option2" />
                                        <label className="form-check-label" for="inlineRadio4">편집</label>
                                    </div>
                                </div>
                            </td>
                            <th style={{ width: "16.66%" }}>미수채권</th>
                            <td>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio5" value="option1" />
                                        <label className="form-check-label" for="inlineRadio5">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio6" value="option2" />
                                        <label className="form-check-label" for="inlineRadio6">편집</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">제품</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>제품</th>
                            <td>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio7" value="option1" />
                                        <label className="form-check-label" for="inlineRadio7">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio8" value="option2" />
                                        <label className="form-check-label" for="inlineRadio8">편집</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">재고</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>재고</th>
                            <td style={{ width: "16.66%" }}>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio9" value="option1" />
                                        <label className="form-check-label" for="inlineRadio9">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio10" value="option2" />
                                        <label className="form-check-label" for="inlineRadio10">편집</label>
                                    </div>
                                </div>
                            </td>
                            <th style={{ width: "16.66%" }}>입고</th>
                            <td style={{ width: "16.66%" }}>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio11" value="option1" />
                                        <label className="form-check-label" for="inlineRadio11">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio12" value="option2" />
                                        <label className="form-check-label" for="inlineRadio12">편집</label>
                                    </div>
                                </div>
                            </td>
                            <th style={{ width: "16.66%" }}>출고</th>
                            <td>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio13" value="option1" />
                                        <label className="form-check-label" for="inlineRadio13">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio14" value="option2" />
                                        <label className="form-check-label" for="inlineRadio14">편집</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>조정</th>
                            <td>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio15" value="option1" />
                                        <label className="form-check-label" for="inlineRadio15">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio16" value="option2" />
                                        <label className="form-check-label" for="inlineRadio16">편집</label>
                                    </div>
                                </div>
                            </td>
                            <th>내역</th>
                            <td>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio17" value="option1" />
                                        <label className="form-check-label" for="inlineRadio17">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio18" value="option2" />
                                        <label className="form-check-label" for="inlineRadio18">편집</label>
                                    </div>
                                </div>
                            </td>
                            <th>분석</th>
                            <td>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio19" value="option1" />
                                        <label className="form-check-label" for="inlineRadio19">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio20" value="option2" />
                                        <label className="form-check-label" for="inlineRadio20">편집</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">고객</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>거래처</th>
                            <td style={{ width: "16.66%" }}>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio21" value="option1" />
                                        <label className="form-check-label" for="inlineRadio21">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio22" value="option2" />
                                        <label className="form-check-label" for="inlineRadio22">편집</label>
                                    </div>
                                </div>
                            </td>
                            <th style={{ width: "16.66%" }}>연락처</th>
                            <td style={{ width: "16.66%" }}>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio23" value="option1" />
                                        <label className="form-check-label" for="inlineRadio23">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio24" value="option2" />
                                        <label className="form-check-label" for="inlineRadio24">편집</label>
                                    </div>
                                </div>
                            </td>
                            <th style={{ width: "16.66%" }}>프로젝트</th>
                            <td>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio25" value="option1" />
                                        <label className="form-check-label" for="inlineRadio25">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio26" value="option2" />
                                        <label className="form-check-label" for="inlineRadio26">편집</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>티어</th>
                            <td colSpan={5}>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio27" value="option1" />
                                        <label className="form-check-label" for="inlineRadio27">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio28" value="option2" />
                                        <label className="form-check-label" for="inlineRadio28">편집</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">지원</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>FAQ</th>
                            <td style={{ width: "16.66%" }}>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio29" value="option1" />
                                        <label className="form-check-label" for="inlineRadio29">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio30" value="option2" />
                                        <label className="form-check-label" for="inlineRadio30">편집</label>
                                    </div>
                                </div>
                            </td>
                            <th style={{ width: "16.66%" }}>1:1문의</th>
                            <td style={{ width: "16.66%" }}>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio31" value="option1" />
                                        <label className="form-check-label" for="inlineRadio31">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio32" value="option2" />
                                        <label className="form-check-label" for="inlineRadio32">편집</label>
                                    </div>
                                </div>
                            </td>
                            <th style={{ width: "16.66%" }}>RMA</th>
                            <td>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio33" value="option1" />
                                        <label className="form-check-label" for="inlineRadio33">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio34" value="option2" />
                                        <label className="form-check-label" for="inlineRadio34">편집</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">관리</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>계정</th>
                            <td style={{ width: "16.66%" }}>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio35" value="option1" />
                                        <label className="form-check-label" for="inlineRadio35">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio36" value="option2" />
                                        <label className="form-check-label" for="inlineRadio36">편집</label>
                                    </div>
                                </div>
                            </td>
                            <th style={{ width: "16.66%" }}>역할</th>
                            <td style={{ width: "16.66%" }}>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio37" value="option1" />
                                        <label className="form-check-label" for="inlineRadio37">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio38" value="option2" />
                                        <label className="form-check-label" for="inlineRadio38">편집</label>
                                    </div>
                                </div>
                            </td>
                            <th style={{ width: "16.66%" }}>항목</th>
                            <td>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio39" value="option1" />
                                        <label className="form-check-label" for="inlineRadio39">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio40" value="option2" />
                                        <label className="form-check-label" for="inlineRadio40">편집</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th style={{ width: "16.66%" }}>매출</th>
                            <td style={{ width: "16.66%" }}>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio41" value="option1" />
                                        <label className="form-check-label" for="inlineRadio41">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio42" value="option2" />
                                        <label className="form-check-label" for="inlineRadio42">편집</label>
                                    </div>
                                </div>
                            </td>
                            <th style={{ width: "16.66%" }}>마이페이지</th>
                            <td colSpan={3} style={{ width: "16.66%" }}>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio43" value="option1" />
                                        <label className="form-check-label" for="inlineRadio43">보기</label>
                                    </div>
                                    <div className="form-check form-check-inline px-0">
                                        <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions" id="inlineRadio44" value="option2" />
                                        <label className="form-check-label" for="inlineRadio44">편집</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </>
    );
}